import { render } from "./ListagemBase.vue?vue&type=template&id=85e26d24&scoped=true"
import script from "./ListagemBase.vue?vue&type=script&lang=js"
export * from "./ListagemBase.vue?vue&type=script&lang=js"

import "./ListagemBase.vue?vue&type=style&index=0&id=85e26d24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e26d24"]])

export default __exports__